<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-14 19:12:19
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2022-10-24 17:36:24
 * @FilePath: /bpm-form/src/components/wgForm/widget-items/wg-input.vue
 * @Description: 描述
 -->
<template>
  <div :title="formatValue" widget-type="number">
    <!-- 使用format 需要同步使用change事件 blur事件获取值为转化后的值 -->
    <!-- :formatter="text => `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" // 增加语言限制
    -->
    <a-input-number v-if="!disabled"
      v-model="text"
      :size="size"
      :data-model="fieldName"
      :max="options.max"
      :min="options.min"
      :disabled="disabled"
      :formatter="text => `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
      :placeholder="disabled?'':placeholder"
      :step="options.step"
      :precision="options.precision"
      :class="options.customClass"
      @blur="handleChange" />
    <a-input-number v-else
      :value="formatValue"
      :size="size"
      :data-model="fieldName"
      :max="options.max"
      :min="options.min"
      :disabled="true"
      :step="options.step"
      :precision="options.precision"
      :class="options.customClass" />
      <!-- 是否开启大写金额大写 -->
    <span v-if="options.isUppercase">{{smallToBig(text)}}</span>
  </div>
</template>
<script>
import numeral from 'numeral';
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
  data() {
    return {
      options: {
        width: '100%',
        format: '',
        required: false,
        defaultValue: null,
        precision: null,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER,
        step: 1,
        disabled: false,
        controlsPosition: '',
        customClass: '',
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
        remoteFunc: '',
        remoteOption: '',
      },
      lastVal: 0,
    };
  },
  computed: {
    formatValue() {
      // 值变化时触发
      const { rowIndex, fieldName: field } = this;
      const value = {
        type: 'number',
        rowIndex,
        field,
        value: this.text,
        item: this.widget,
      };
      this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
      if (this.options.format) {
        if (this.text || this.text === 0) {
          return numeral(this.text).format(this.options.format);
        }
        return null;
      }
      return this.text;
    },
  },
  methods: {
    initVal(val) {
      this.text = this.valueToNumber(val);
    },
    handleChange(e) {
      const val = e.target.value || this.defaultValue;
      const newVal = this.valueToNumber(val.replace(/(,*)/g, '')); // 兼容千分制数字输入检验
      if (!this.isNested) {
        const { rowIndex, fieldName: field } = this;
        const value = {
          type: 'number',
          rowIndex,
          field,
          value: newVal,
        };
        this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
      }
      // 将数据抛给上一层，主要是被子表格服务
      this.$emit('change', newVal);
    },
    smallToBig(money) {
      //  将数字金额转换为大写金额
      const cnNums = [
        '零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']; // 汉字的数字
      const cnIntRadice = ['', '拾', '佰', '仟']; // 基本单位
      const cnIntUnits = ['', '万', '亿', '兆']; // 对应整数部分扩展单位
      const cnDecUnits = ['角', '分', '毫', '厘']; // 对应小数部分单位
      const cnInteger = '整'; // 整数金额时后面跟的字符
      const cnIntLast = '元'; // 整数完以后的单位
      // 最大处理的数字
      const maxNum = 999999999999999.9999;
      let integerNum = ''; // 金额整数部分
      let decimalNum; // 金额小数部分
      // 输出的中文金额字符串
      let chineseStr = '';
      // let parts; //分离金额后用的数组，预定义
      if (money === '' || money === undefined || money === null) {
        return '';
      }
      money = parseFloat(money);
      if (money >= maxNum) {
        // 超出最大处理数字
        return '超出最大处理数字';
      }
      if (money === 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
      }

      // 四舍五入保留两位小数,转换为字符串
      money = Math.round(money * 100).toString();
      integerNum = money.substr(0, money.length - 2);
      if (money.length < 2) {
        const str = '00000000000000000000000';
        decimalNum = str.substr(0, 2 - money.length) + money.substr(money.length - 2);
      } else {
        decimalNum = money.substr(money.length - 2);
      }
      // 获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0;
        const IntLen = integerNum.length;
        for (let i = 0; i < IntLen; i += 1) {
          const n = integerNum.substr(i, 1);
          const p = IntLen - i - 1;
          const q = p / 4;
          const m = p % 4;
          if (n === '0') {
            zeroCount += 1;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            // 归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n, 10)] + cnIntRadice[m];
          }
          if (m === 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }
      // 小数部分
      if (decimalNum !== '') {
        const decLen = decimalNum.length;
        for (let i = 0; i < decLen; i += 1) {
          const n = decimalNum.substr(i, 1);
          if (n !== '0') {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (chineseStr === '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum === '' || /^0*$/.test(decimalNum)) {
        chineseStr += cnInteger;
      }
      return chineseStr;
    },
  },
};
</script>
